import { accountRoutes } from '@/router/route-modules/account.routes';
import { accountToolRoutes } from '@/router/route-modules/account-tool.routes';
import { accountSettingsRoutes } from '@/router/route-modules/account-settings.routes';
import { documentsRoutes } from '@/router/route-modules/documents.routes';

import {
  PageWrapper,
  Accounts,
  InactiveAccounts,
  ContactUs,
  Login,
  Register,
  LoggedOut,
  Notifications,
  Resources,
  MyDocuments,
  DocumentDetail,
  SSOError,
  SelectGroup,
  SubstantiateClaims,
  LoadingPage,
  FederatedLogOut,
  InterestRates,
  GetSaId,
  FederateHQY,
} from '@/pages';
import { EventBus } from '@/event-bus';
import { InformationPage } from '@/components/information-page-component';
import store from '@/store';
import { RouteConfig } from 'vue-router';
import { AuthService } from '@/services';

// @ts-ignore
const baseRouteRedirect = process.styleguide
  ? ''
  : { redirect: { name: 'accounts' } }; // eslint-disable-line no-undef

export const routes: RouteConfig[] = [
  {
    name: 'base',
    path: '/',
    ...baseRouteRedirect,
    component: PageWrapper,
    children: [
      {
        name: 'accounts',
        path: '/accounts',
        component: Accounts,
      },
      {
        name: 'inactiveAccounts',
        path: '/inactive-accounts',
        component: InactiveAccounts,
      },
      accountRoutes,
      {
        name: 'notifications',
        path: '/notifications',
        component: Notifications,
      },
      {
        name: 'nonDiscrimination',
        path: '/non-discrimination',
        props: {
          contentArea: 'non-discrimination-page-content',
        },
        component: InformationPage,
      },
      {
        name: 'legalTermsOfUse',
        path: '/legal-terms-of-use',
        props: {
          contentArea: 'legal-terms-of-use-page-content',
        },
        component: InformationPage,
      },
      // {
      //   name: 'privacyPolicy',
      //   path: '/privacy-policy',
      //   props: {
      //     contentArea: 'privacy-policy-page-content',
      //   },
      //   component: InformationPage,
      // },
      {
        name: 'securityPolicy',
        path: '/security-policy',
        props: {
          contentArea: 'security-policy-page-content',
        },
        component: InformationPage,
      },
      {
        name: 'contactUs',
        path: '/contact-us',
        component: ContactUs,
      },
      {
        name: 'resources',
        path: '/resources',
        component: Resources,
      },
      {
        name: 'myDocuments',
        path: '/my-records-and-receipts',
        component: MyDocuments,
      },
      accountSettingsRoutes,
      {
        name: 'substantiateClaims',
        path: '/substantiate-claims',
        component: SubstantiateClaims,
      },
      {
        name: 'interestRates',
        path: '/interest-rates',
        component: InterestRates,
      },
    ],
  },
  ...accountToolRoutes,
  ...documentsRoutes,
  {
    name: 'login',
    path: '/login',
    component: Login,
    beforeEnter(to, from, next) {
      if (!to.query.code) {
        EventBus.$emit('initialLoadDone');
      }
      next();
    },
  },
  {
    name: 'register',
    path: '/register',
    component: Register,
    beforeEnter(to, from, next) {
      EventBus.$emit('initialLoadDone');
      next();
    },
  },
  {
    name: 'forgotPassword',
    path: '/forgot-password',
    redirect: {
      name: 'login',
      params: {
        launchModal: 'forgot-password',
      },
    },
    beforeEnter(to, from, next) {
      EventBus.$emit('initialLoadDone');
      next();
    },
  },
  {
    name: 'forgotUsername',
    path: '/forgot-username',
    redirect: {
      name: 'login',
      params: {
        launchModal: 'forgot-username',
      },
    },
    beforeEnter(to, from, next) {
      EventBus.$emit('initialLoadDone');
      next();
    },
  },
  {
    name: 'federateHQY',
    path: '/federate-HQY',
    component: FederateHQY,
    beforeEnter(to, from, next) {
      EventBus.$emit('initialLoadDone');
      next();
    },
  },
  {
    name: 'getSaId',
    path: '/get-sa-id',
    component: GetSaId,
    beforeEnter(to, from, next) {
      if (!to.query.uuid || !to.query.otp) {
        next('login');
        return;
      }
      EventBus.$emit('initialLoadDone');
      next();
    },
  },
  {
    name: 'loggedOut',
    path: '/logged-out',
    component: LoggedOut,
    beforeEnter(to, from, next) {
      EventBus.$emit('initialLoadDone');
      next();
    },
  },
  {
    name: 'federatedLogOut',
    path: '/federated-log-out',
    component: FederatedLogOut,
    beforeEnter(to, from, next) {
      AuthService.singleSignOutUser(true);
      EventBus.$emit('initialLoadDone');
      next();
    },
  },
  {
    name: 'submitOnlineApp',
    path: '/online-application',
    component: LoadingPage,
    meta: {
      transitionIn: 'slide-up',
      transitionMode: 'in-out',
    },
    children: [
      {
        name: 'submitOnlineAppStepper',
        path: ':step',
        component: LoadingPage,
        meta: {
          transitionIn: 'slide-up',
          transitionMode: 'in-out',
        },
      },
    ],
  },
  {
    name: 'documentDetail',
    path: '/document-detail/:documentID',
    component: DocumentDetail,
    meta: {
      transitionIn: 'slide-up',
      transitionMode: 'in-out',
    },
  },
  {
    name: 'ssoError',
    path: '/unauthorized',
    component: SSOError,
    beforeEnter(to, from, next) {
      EventBus.$emit('initialLoadDone');
      next();
    },
  },
  {
    name: 'selectGroup',
    path: '/select-group',
    component: SelectGroup,
    beforeEnter(to, from, next) {
      EventBus.$emit('initialLoadDone');
      next();
    },
  },
  {
    name: 'interestRate',
    path: '/interest-rate',
    component: InterestRates,
  },
  {
    name: 'loading',
    path: '/loading',
    component: LoadingPage,
  },
  {
    path: '*',
    component: PageWrapper,
    redirect: {
      name: 'accounts',
    },
  },
];
